import useLocalStorageState from 'use-local-storage-state';
import { parseToken } from '@/store/user/reducer/parseToken';

export function useTokenState() {
  return useLocalStorageState('token');
}

export function useActiveProfile() {
  const [token] = useTokenState();

  return parseToken(token);
}

export function isActiveProfileValid(activeProfileId) {
  return Boolean(activeProfileId) && activeProfileId !== '0';
}
